import { nanoid } from 'nanoid';
import { getSchemaByCategory } from '@monestry-dev/schema';
import { postAccount, getDataByAccount } from '../../../redux/reducers/data';
import { setMessage } from '../../../redux/actions/message';

// Validate against schema, cast payload, dispatch postAccount
export async function handleValidateAndDispatchAccount({ category, userInput, dispatch, setLoading }) {
  const accountSchema = getSchemaByCategory(category, 'account');
  let payload;
  try {
    const validated = accountSchema.validateSync(userInput);
    payload = accountSchema.cast(validated, { stripUnknown: true });
  } catch (error) {
    console.error('Error casting accountSchema', error);
    if (error.inner) {
      error.inner.forEach((err) => console.error(`Field: ${err.path}, Error: ${err.message}`));
    }
    throw new Error('Validation error (add account).');
  }

  try {
    const resultDispatch = await dispatch(postAccount({ data: payload, category }));
    if (resultDispatch.error) throw new Error('AddAccount > dispatchUserInput: Dispatch postAccount returned an error');
    return { resultDispatch, payload };
  } catch (error) {
    console.error('Error: AddAccount: postAccount failed', error);
    if (setLoading) setLoading(false);
    dispatch(setMessage('accountCouldNotBeCreated'));
    throw error;
  }
}

// Handles connectedDepositMode for non-deposit categories.
// - existingAccount: copies selected id into connectedDepositAccounts
// - createTechnicalAccount: creates a manual deposit account and wires its id
export async function handleConnectedDepositMode(flattenedUserInput, { dispatch }) {
  let updatedInput = { ...flattenedUserInput };

  if (updatedInput.connectedDepositMode === 'existingAccount') {
    updatedInput = {
      ...updatedInput,
      connectedDepositAccounts: [updatedInput.connectedDepositAccountObject],
    };
  }

  if (updatedInput.connectedDepositMode === 'createTechnicalAccount') {
    const newDepositAccountId = nanoid();
    updatedInput = {
      ...updatedInput,
      connectedDepositAccounts: [newDepositAccountId],
    };
    const depositAccount = {
      id: newDepositAccountId,
      name: updatedInput.name,
      bankName: updatedInput.brokerName,
      currency: updatedInput.currency,
      countryCode: updatedInput.countryCode,
      depositType: 'savings-account',
      syncType: 'manual',
      tags: {},
    };
    const payloadDeposit = getSchemaByCategory('deposits', 'account').cast(depositAccount);
    await dispatch(postAccount({ data: payloadDeposit, category: 'deposits' }));
  }

  return updatedInput;
}

export async function maybeTriggerSync({ payload, category, dispatch, accountId }) {
  if (payload?.syncType === 'automatic') {
    dispatch(getDataByAccount({ category, accountId }));
  }
}
